// tslint:disable
import createHistory from 'history/createBrowserHistory';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import GoogleAnalytics from './components/GoogleAnalytics';
import ForwardAuthentication from './components/ForwardAuthentication';
import PublicErrorPage from './components/PublicErrorPage';
import App from './containers/App';
import Callback from './containers/Callback';
import HomePage from './containers/HomePage';
import Maintenance from './containers/Maintenance';
import SignUp from './containers/SignUp';
import SilentCallback from './containers/SilentCallback';
import TermsAndConditions from './containers/TermsAndConditions';
import reducers from './reducers';
// import registerServiceWorker from './registerServiceWorker';
import { AuthLogic } from './auth/AuthLogic';

import './styles/main.css';
import './styles/plugins/select2.css';

const history = createHistory();
const routerReduxMiddleware = routerMiddleware(history);

const composeEnhancers =
  // tslint:disable-next-line:no-any
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(routerReduxMiddleware, thunk))
);

AuthLogic.getInstance().restartRenewTimer();

if (process.env.NODE_ENV === 'production') {
  // tslint:disable-next-line:no-any
  ReactGA.initialize((window as any).__REACT_SETTINGS.googleAnalyticsKey);

    history.listen(location => {
    GoogleAnalytics.save(location);
  });
}

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <main>
        <section>
          <GoogleAnalytics />
          <ForwardAuthentication />
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route
              exact
              path="/terms-and-conditions"
              component={TermsAndConditions}
            />
            <Route path="/callback" component={Callback} />
            <Route
                path="/silent-callback"
                component={SilentCallback}
            />
            <Route path="/app" component={App} />
            <Route path="/sign-up" component={SignUp} />
            <Route path="/maintenance" component={Maintenance} />
            <Route component={PublicErrorPage} />
          </Switch>
        </section>
      </main>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx